import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-line py-16 px-6 lg:px-8 bg-card">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-5 gap-10">
        {/* Brand */}
        <div className="lg:col-span-2">
          <Link to="/" className="flex items-center gap-2 font-semibold text-[15px] tracking-tight text-ink mb-3">
            <span className="w-7 h-7 rounded-[8px] bg-blue flex items-center justify-center text-white">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </span>
            Consentry
          </Link>
          <p className="mono text-[12.5px] text-muted">Consent. Logged. Certified.</p>
        </div>

        {/* Developers */}
        <div>
          <div className="text-[11.5px] font-semibold text-muted uppercase tracking-wider mb-4">
            Developers
          </div>
          <ul className="space-y-2.5 text-[13.5px] text-sub">
            <li>
              <a href="#developers" className="hover:text-ink transition-colors">
                Documentation
              </a>
            </li>
            <li>
              <a href="#developers" className="hover:text-ink transition-colors">
                API Reference
              </a>
            </li>
            <li>
              <a href="#features" className="hover:text-ink transition-colors">
                Changelog
              </a>
            </li>
            <li>
              <a href="#demo" className="hover:text-ink transition-colors">
                Status
              </a>
            </li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <div className="text-[11.5px] font-semibold text-muted uppercase tracking-wider mb-4">
            Company
          </div>
          <ul className="space-y-2.5 text-[13.5px] text-sub">
            <li>
              <a href="#" className="hover:text-ink transition-colors">
                Blog
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-ink transition-colors">
                GitHub
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-ink transition-colors">
                LinkedIn
              </a>
            </li>
            <li>
              <a href="#pricing" className="hover:text-ink transition-colors">
                Contact
              </a>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <div className="text-[11.5px] font-semibold text-muted uppercase tracking-wider mb-4">
            Legal
          </div>
          <ul className="space-y-2.5 text-[13.5px] text-sub">
            <li>
              <a href="#" className="hover:text-ink transition-colors">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-ink transition-colors">
                Terms of Service
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-ink transition-colors">
                Data Processing
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-line flex flex-col sm:flex-row justify-between gap-3 text-[12px] text-muted">
        <span>© 2026 Consentry — a Parakrama Technologies product. All rights reserved.</span>
        <span className="mono">v1.4.2 · GA · Mumbai · Bengaluru · Delhi NCR</span>
      </div>
    </footer>
  );
}
